<template>
  <div>
    <div v-if="sideQueryResult && !embedded" :class="embedded?'sideQueryOverlayEmbedded':'sideQueryOverlay'"> {{ sideQueryResult }}</div>

    <div class="btnFab">
      <q-fab v-model="fab1" v-if="sideQueryResult && embedded"
             color="white" text-color="black" icon="keyboard_arrow_right" direction="right" padding="xs">
        <div v-if="sideQueryResult" class="sideQueryOverlayEmbedded"> {{ sideQueryResult }}</div>
      </q-fab>
      <q-tooltip>{{ sideQueryResult }}</q-tooltip>
    </div>
  </div>

</template>

<script>
import { useQueryStore } from '../../stores/QueryStore.js'

export default {
  name: 'sideQueryOverlay',
  props: ['queryID', 'queryParams', 'embedded'],
  components: {},

  data() {
    return {
      sideQueryResult: null,
      fab1: false
    }
  },

  methods: {
    executeSideQuery() {
      const queryStore = useQueryStore()
      let myParameter = []
      if (this.queryParams) {
        myParameter = Object.assign([], this.queryParams)
        myParameter.map((param) => delete param.component)
      }
      queryStore.execQuery({queryID: this.queryID, queryParameter: myParameter, sideQuery: true})
        .then(() => {
          if (queryStore.queryResultRows.length >= 1 && queryStore.queryColumns.length >= 1) {
            this.sideQueryResult = queryStore.queryResultRows[0].cell[0]
          }
        })
    }
  },

  mounted() {
    this.executeSideQuery()
  }
}

</script>

<style lang="sass">
.sideQueryOverlay
  position: absolute
  background-color: white
  border-radius: 1px
  bottom: 25px
  left: 10px
  z-index: 2
  width: 300px
  min-height: 80px
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2)
  padding: 10px
  font-size:14px


.sideQueryOverlayEmbedded
  background-color: white
  border-radius: 1px
  width: 250px
  min-height: 60px
  box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.2)
  padding: 10px
  font-size:12px


.btnFab
  position: absolute
  bottom: 30px
  left: 10px

</style>
